module.exports = __webpack_public_path__ + "public/images/modals/netw-start-conversation-desktop.992279dfb0298005ceda9151437d2704.png";